<template>
  <div class="about">
    <div class="info">
      <h2>
        <span class="fontsize20">{{$t('nav.w35')}}</span>
        <br>
        <span class="fontsize12 color-g">COMPANY PROFILE</span>
      </h2>
      <div v-html="$t('other.w39')"></div>
    </div>
    <div class="box">
      <h2>
        <span class="fontsize20">{{$t('title.w17')}}</span>
        <br>
        <span class="fontsize12 color-g">OUR ADVANTAGES</span>
      </h2>
      <p class="line">
        <img src="../assets/about/pic_line@2x.png" alt>
      </p>
      <div class="advantages">
        <ul class="ad1">
          <li>
            <span>{{$t('other.w40')}}</span>
            <span class="color-g3">{{$t('other.w41')}}</span>
          </li>
          <li>
            <span>{{$t('other.w42')}}</span>
            <span class="color-g3">{{$t('other.w43')}}</span>
          </li>
          <li>
            <span>{{$t('other.w44')}}</span>
          </li>
        </ul>
        <ul class="ad2">
          <li>
            <span>{{$t('other.w45')}}</span>
            <span class="color-g3">{{$t('other.w46')}}</span>
          </li>
          <li>
            <span>{{$t('other.w47')}}</span>
            <span class="color-g3">{{$t('other.w48')}}</span>
          </li>
          <li>
            <span>{{$t('other.w49')}}</span>
            <span class="color-g3">{{$t('other.w50')}}</span>
          </li>
        </ul>
      </div>
      <h2>
        <span class="fontsize20">{{$t('title.w18')}}</span>
        <br>
        <span class="fontsize12 color-g">SAFETY GUARANTEE</span>
      </h2>
      <p class="line">
        <img src="../assets/about/pic_line@2x.png" alt>
      </p>
      <div class="guarantee">
        <ul>
          <li>
            <span>{{$t('other.w51')}}</span>
            <span class="color-g3">{{$t('other.w52')}}</span>
          </li>
          <li>
            <span>{{$t('other.w53')}}</span>
            <span class="color-g3">{{$t('other.w54')}}</span>
          </li>
          <li>
            <span>{{$t('other.w55')}}</span>
            <span class="color-g3">{{$t('other.w56')}}</span>
          </li>
          <li>
            <span>{{$t('other.w57')}}</span>
            <span class="color-g3">{{$t('other.w58')}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <p>
        <i class="icon1"></i> （+86）400-886-3306
      </p>
      <p>
        <i class="icon2"></i>kf@rzj.com
      </p>
      <p>
        <i class="icon3"></i><span class="mar-r15">997774555</span><span class="mar-r15">997774515</span><span class="mar-r15">997774929</span><span class="mar-r15">1536926666</span><span class="mar-r15">1362386666</span><span>997774989</span>   
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.about {
  margin: 0 auto;
  width: 1200px;
  font-size: 14px;
  color: #232325;
  .mar-r15{
    margin-right: 25px;
  }
  .info {
    height: 350px;
    width: 1200px;
    letter-spacing: 1px;
    padding-top: 60px;
    margin: 20px;
    background: url("../assets/about/about_bg@2x.png") right no-repeat;
    background-size: 414px 350px;
  }
  .box {
    height: 730px;
    padding: 10px;
    background: #fff;
    border-radius: 8px;
    h2 {
      padding: 30px 0 0 40px;
    }
    .line {
      height: 20px;
      margin: 20px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    ul {
      min-width: 480px;
      padding-left: 20px;
      margin: 40px;
      li {
        list-style: disc;
        color: #99c1fb;
        margin-bottom: 5px;
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        span {
          font-size: 14px;
          color: #232325;
        }
        .color-g3 {
          color: #a2a2a2;
        }
      }
    }

    .advantages {
      display: flex;
      margin: 0 30px;
      border-bottom: 1px dashed #ddd;
      .ad1 {
        background: url("../assets/about/about_pic1@2x.png") right no-repeat;
        background-size: 188px;
      }
      .ad2 {
        background: url("../assets/about/about_pic2@2x.png") right no-repeat;
        background-size: 188px;
      }
    }
    .guarantee {
      height: 240px;
      margin: 0 70px 0 50px;
      background: url("../assets/about/safety_pic@2x.png") right no-repeat;
      background-size: 300px 200px;
      ul {
        padding-top: 20px;
        padding-left: 0;
      }
    }
  }
  .contact {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: #fff;
    font-size: 16px;
    margin: 40px 0;
    background: linear-gradient(90deg, #4969a6 0%, #23386d 100%);
    border-radius: 8px;
    i {
      display: inline-block;
      width: 27px;
      height: 27px;
      vertical-align: bottom;
      margin-right: 20px;
      background-image: url("../assets/about/27pic_ico@2x.png");
      background-size: cover;
    }
    .icon1 {
      background-position: 0 0;
    }
    .icon2 {
      background-position: 0 -27px;
    }
    .icon3 {
      background-position: 0 27px;
    }
  }
  h2 {
    line-height: 20px;
    font-weight: bold;
  }
  .color-g {
    color: #7b7b7c;
  }
  /deep/ .color-g2 {
    width: 670px;
    color: #3d3d3f;
    margin-top: 20px;
  }
  .fontsize12 {
    font-size: 12px;
  }
  .fontsize16 {
    font-size: 16px;
  }
  .fontsize20 {
    font-size: 20px;
  }
}
</style>
